/**
 * Created by Jonas Wålekvist on 2018-04-26.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {Linear, TimelineLite, TweenLite} from "gsap"
import {DungeonQuestLayerConfig} from "../../../config/DungeonQuestLayerConfig";
import {ShakeUtil} from "../../../utils/ShakeUtil";
import {DungeonQuestHelper} from "../../bigSymbols/DungeonQuestHelper";
import {ShakeEffect} from "../../display/effects/ShakeEffect";
import {DungeonQuest} from "../../DungeonQuest";
import {DungeonQuestGameAssets} from "../../DungeonQuestGameAssets";
import {DungeonQuestGameConfig, DungeonQuestSymbols} from "../../DungeonQuestGameConfig";
import {DungeonQuestSound} from "../../DungeonQuestSound";
import {ColossalSymbolInfo} from "../../server/data/DungeonQuestParsedGameData";


export class DungeonQuestRandomColossalWildView extends BaseView {
    private _separation:TimelineSprite;
    private _separationGlow:TimelineSprite;
    private _explosion:TimelineSprite;
    private _symbolOverlay:PIXI.Sprite;
    private _explosionSmoke:TimelineSprite;
    private _landingSmoke:TimelineSprite;


    get shakeEffect():ShakeEffect {
        if(!this._shakeEffect) {
            this._shakeEffect = ShakeUtil.createDefaultShake();
        }
        return this._shakeEffect;
    }

    private _layer:ScalableLayer;
    private _symbolGlow:TimelineSprite;
    private _symbol:PIXI.Sprite;

    private _shakeEffect:ShakeEffect;
    private _colossalContainer:PIXI.Container;

    constructor(resourceGroup?:ResourcesGroupName) {
        super(resourceGroup);
        this._layer = StageManager.getLayer(DungeonQuestLayerConfig.SYMBOLS_OVERLAY.name);
        this._layer.addChild(this);
    }

    protected onResize(resizeData:IResizeData):void {
        this._layer.y = StageManager.getLayer(DungeonQuestLayerConfig.SYMBOLS.name).y;
    }

    protected initAnimations():void {
        this._colossalContainer = new PIXI.Container();
        this._symbolGlow = new TimelineSprite(GameResources.getTextures(DungeonQuestGameAssets.RANDOM_WILD_CRACK_GLOW));
        this._symbolGlow.anchor.set(0.5, 0.5);
        this._symbolGlow.position.set(131, 105);


        const colossalTexture = GameResources.getTextures(DungeonQuestGameAssets.RANDOM_WILD_COLOSSAL_STILL)[0];
        this._symbol = new PIXI.Sprite(colossalTexture);
        this._symbol.anchor.set(0.5, 0.5);
        this._symbol.position.set(DungeonQuestGameConfig.instance.SYMBOL_WIDTH, DungeonQuestGameConfig.instance.SYMBOL_HEIGHT);


        this._symbolOverlay = new PIXI.Sprite(DungeonQuest.colorEffectTextureCache.getWhiteTexture(colossalTexture));
        this._symbolOverlay.anchor.set(0.5, 0.5);
        this._symbolOverlay.tint = DungeonQuestHelper.getDarkenColor();
        this._symbol.addChild(this._symbolOverlay);

        this._landingSmoke = new TimelineSprite(GameResources.getTextures(DungeonQuestGameAssets.RANDOM_WILD_LANDING_SMOKE));
        this._landingSmoke.anchor.set(0.5, 0.5);
        this._landingSmoke.position.set(DungeonQuestGameConfig.instance.SYMBOL_WIDTH, DungeonQuestGameConfig.instance.SYMBOL_HEIGHT);
        this._landingSmoke.hide();


        this._separation = new TimelineSprite(GameResources.getTextures(DungeonQuestGameAssets.RANDOM_WILD_SEPARATION));
        this._separation.anchor.set(0.5, 0.5);
        this._separation.position.set(126, 120);
        this._separation.hide();

        this._separationGlow = new TimelineSprite(GameResources.getTextures(DungeonQuestGameAssets.RANDOM_WILD_SEPARATION_GLOW));
        this._separationGlow.anchor.set(0.5, 0.5);
        this._separationGlow.position.set(126, 120);
        this._separationGlow.hide();

        this._explosion = new TimelineSprite(GameResources.getTextures(DungeonQuestGameAssets.RANDOM_WILD_EXPLOSION));
        this._explosion.anchor.set(0.5, 0.5);
        this._explosion.position.set(DungeonQuestGameConfig.instance.SYMBOL_WIDTH, DungeonQuestGameConfig.instance.SYMBOL_HEIGHT);
        this._explosion.hide();

        this._explosionSmoke = new TimelineSprite(GameResources.getTextures(DungeonQuestGameAssets.RANDOM_WILD_EXPLOSION_SMOKE));
        this._explosionSmoke.anchor.set(0.5, 0.5);
        this._explosionSmoke.position.set(97, 70);
        this._explosionSmoke.hide();

        this._symbolGlow.blendMode = PIXI.BLEND_MODES.ADD;
        this._separationGlow.blendMode = PIXI.BLEND_MODES.ADD;
        this._explosion.blendMode = PIXI.BLEND_MODES.ADD;

        this._colossalContainer.addChild(this._landingSmoke);
        this._colossalContainer.addChild(this._symbol);
        this._colossalContainer.addChild(this._symbolGlow);
        this._colossalContainer.addChild(this._explosionSmoke);
        this._colossalContainer.addChild(this._explosion);
        this._colossalContainer.addChild(this._separationGlow);
        this._colossalContainer.addChild(this._separation);

        this._colossalContainer.visible = false;


        this.addChild(this._colossalContainer);

    }

    private tintGlows(color:number) {
        this._symbolGlow.tint = color;
        this._separationGlow.tint = color;
        this._explosion.tint = color;


        this._symbolGlow.setFrame(0);
        this._separationGlow.setFrame(0);
        this._explosion.setFrame(0);

    }

    public getLandingAnimation(colossalData:ColossalSymbolInfo, symbol:string, dimAndHighlightSymbolAnimation:TimelineLite):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        this._colossalContainer.position.set(
            DungeonQuestGameConfig.instance.SYMBOL_WIDTH * colossalData.position[0] + 10,
            DungeonQuestGameConfig.instance.SYMBOL_HEIGHT * colossalData.position[1]
        );
        this.tintGlows(DungeonQuestHelper.getSymbolColor(symbol));

        const symbolsToHide:StateReelSymbol[] = [];

        symbolsToHide.push(Reels.getSymbol(colossalData.position[0], colossalData.position[1])!);
        symbolsToHide.push(Reels.getSymbol(colossalData.position[0] + 1, colossalData.position[1])!);
        symbolsToHide.push(Reels.getSymbol(colossalData.position[0], colossalData.position[1] + 1)!);
        symbolsToHide.push(Reels.getSymbol(colossalData.position[0] + 1, colossalData.position[1] + 1)!);

        const hideSymbolsTL = new TimelineLite();
        for(let hideSym of symbolsToHide) {
            hideSymbolsTL.add(() => (<StateReelSymbol>hideSym).replaceWith(DungeonQuestSymbols.NONE, hideSym.reelId));
        }


        tl.add([
            () => this._colossalContainer.visible = true,
            () => this._symbol.visible = true,
            () => this._symbolGlow.hide(),
            () => this._symbolGlow.alpha = 1,
            () => this._symbol.scale.set(2),
            () => this._symbol.alpha = 0,
            () => this._symbolOverlay.alpha = 0.65
        ]);

        const landEase:CustomEase = CustomEase.create("custom", "M0,0 C0.46,0 0.612,0.014 0.732,0.088 0.85,0.161 1,0.396 1,1");
        tl.add([
            new TweenLite(this._symbol, 0.2, {ease : Linear.easeNone, alpha : 1}),
            new TweenLite(this._symbol.scale, 0.6, {ease : landEase, x : 1.0, y : 1.0}),
            new TweenLite(this._symbolOverlay, 0.6, {ease : landEase, alpha : 0}),
        ]);
        tl.add(hideSymbolsTL, 0.2);

        tl.add(() => SlotGame.sound.playEffect(DungeonQuestSound.RANDOM_WILD_COLOSSAL_LAND), "-=0.2");


        tl.add([
            this._landingSmoke.getAnimationAutoShowHide(true, true),
            this.shakeEffect.getOneShotShake(0.5),
            DungeonQuest.symbolTransformView.getLandingShockWave(colossalData),
        ]);


        tl.add([
            () => SlotGame.sound.playEffect(DungeonQuestSound.RANDOM_WILD_BUILD_UP),
            dimAndHighlightSymbolAnimation,
            this._symbolGlow.getAnimationAutoShowHide(true, false)
        ]);


        tl.add([
            () => SlotGame.sound.playEffect(DungeonQuestSound.RANDOM_WILD_CRACK),
            this._separation.getAnimationAutoShowHide(true, true),
            this._separationGlow.getAnimationAutoShowHide(true, true),
            () => this._symbol.visible = false,
            () => this._symbolGlow.hide()
        ]);


        return tl;
    }

    public getExplosionAnimation():TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add([
            this._explosion.getAnimationAutoShowHide(true, true),
            this._explosionSmoke.getAnimationAutoShowHide(true, true)
        ]);
        tl.add(() => this._colossalContainer.visible = false);
        return tl;
    }


}